import { makeWorkbook } from "../../utils/excel";
import { getIndicatorCaes } from "../../../../../../rest/indicator";

export async function buildWorkbookCae() {
  const resp = await getIndicatorCaes();
  const payload = resp?.data || {};
  const list = Array.isArray(payload?.data) ? payload.data : payload || [];

  const sum = (arr, f) => arr.reduce((s, it) => s + Number(it?.[f] || 0), 0);
  const totalAll = sum(list, "counter");
  const distinctCae = list.length;

  const STATES = [
    { key: "sumApproved", label: "Aprovadas" },
    { key: "sumEligibility", label: "Por tratar" },
    { key: "sumOthers", label: "Em tratamento" },
    { key: "sumRevocation", label: "Revogação" },
    { key: "sumRejected", label: "Indeferidas" },
  ];

  const totalsByState = STATES.map((s) => ({
    label: s.label,
    value: sum(list, s.key),
  }));

  const pctFrac = (v, t) => (t > 0 ? Number(v) / Number(t) : 0);

  const resumoAoa = [
    ["Indicador", "Valor"],
    ["Total de candidaturas", Number(totalAll || 0)],
    ["CAE distintos", Number(distinctCae || 0)],
  ];

  const distribuicaoAoa = [
    ["Estado", "Valor", "% do total"],
    ...totalsByState.map((s) => [
      s.label,
      Number(s.value || 0),
      pctFrac(s.value, totalAll),
    ]),
  ];

  const sorted = list
    .slice()
    .sort((a, b) => Number(b?.counter || 0) - Number(a?.counter || 0));
  const porCaeAoa = [
    ["CAE", "Descrição", "Total", "% do total"],
    ...sorted.map((i) => [
      i?.code ?? "",
      i?.description ?? "",
      Number(i?.counter || 0),
      pctFrac(i?.counter || 0, totalAll),
    ]),
  ];

  return makeWorkbook([
    { name: "Resumo", aoa: resumoAoa },
    { name: "Distribuicao", aoa: distribuicaoAoa, percentCols: [2] },
    { name: "Por_CAE", aoa: porCaeAoa, percentCols: [3] },
  ]);
}
